import type { IconSvgObject } from './types';

const ChartLineData03Icon: IconSvgObject = [
  ["path", { d: "M21 8.33333C20.0748 7.03165 18.8647 6 16.9782 6C8.4681 6 12.9194 20.5 5 20.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartLineData03Icon;
